import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { IOptionsResponse } from '../../../common/common.types'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'
import { OptionsService } from '../services/options.service'
import { setAutoManualOptions } from '../store/options.actions'

export function* getAutoManualOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const autoManualOptionsResponse: IOptionsResponse = yield call([
      optionsService,
      optionsService.getAutoManualOptions,
    ])
    const { entity } = autoManualOptionsResponse
    if (entity) yield put(setAutoManualOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getAutoManualOptions() error: ${e}`))
  }
}

export function* getAutoManualOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getAutoManualOptions)
}
